import React from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
//import Kiosk from "../assets/images/kiosk.svg";

import { accountService, alertService } from '../_services';
import { useTranslation } from "react-i18next";
import { GoogleLoginButton } from '../_components';

function Login({ history, location }) {
    const { t } = useTranslation();
    const initialValues = {
        email: '',
        password: ''
    };

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .email(t('Email is invalid'))
            .required(t('Email is required')),
        password: Yup.string().required(t('Password is required'))
    });

    function onSubmit({ email, password }, { setSubmitting }) {
        alertService.clear();
        accountService.login(email, password)
            .then(() => {
                const { from } = location.state || { from: { pathname: "/" } };
                history.push(from);
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h2 className="card-header">Pocket Kiosk Locker App</h2>

                    <div className="card-body">
                        {t('login.intro')} <br />
                        {t('Please')} <Link to="register" className="btn btn-link">{t('Create An Account')}</Link> {t('login.orLoginBelow')}.
                    </div>
                    <div className="card-body text-center" style={{ width: "fit-content" }}>
                        <GoogleLoginButton />
                    </div>
                    <div className="card-body">
                        <div className="form-group col-6 em-pw-lgth">
                            <label>Email</label>
                            <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
                            <ErrorMessage name="email" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group col-6 em-pw-lgth">
                            <label>{t('Password')}</label>
                            <Field name="password" type="password" className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
                            <ErrorMessage name="password" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-row">
                            <div className="form-group row">
                                <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                                    {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                    {t('Login')}
                                </button>
                                <Link to="forgot-password" className="btn btn-link pr-0 cancel-marg">{t('Forgot Password')}?</Link>
                            </div>
                        </div>

                    </div>

                </Form>
            )}
        </Formik>
    )
}

export { Login };